import React from "react";
import { FacebookShareButton, WhatsappShareButton, EmailShareButton, TwitterShareButton } from "react-share";
import { InputGroup } from "@blueprintjs/core";
import { CopyToClipboard } from "react-copy-to-clipboard";
import CustomIcon from "../../components/CustomIcon";
import { connect } from "react-redux";
import { getCreatedCircle } from "../../store/b2b_button/selectors";
import { Translate } from "react-redux-i18n";

class ShareYourGroup extends React.Component {
  render() {
    if (!this.props.circle) {
      return null;
    }
    let circle_url = `https://app.ihopa.com/circle/${this.props.circle.guid}`;

    return (
      <div className="circle-notification-cta social-share">
        <p>
          <Translate value="b2b.share_step_copy" />
        </p>
        <div className="circle-notification-cta b2b-copy-to-clipboard">
          <div className="notification-content">
            <InputGroup className="no-icon" type="text" fill={true} disabled={true} value={circle_url} />
            <div className="copy-to-clipboard-button">
              <CopyToClipboard text={circle_url}>
                <span>
                  <CustomIcon name="b2b-url" className="icon" size="24" />
                </span>
              </CopyToClipboard>
            </div>
          </div>
        </div>
        <div className="b2b-share-group no-margin">
          <div className="share-buttons-wrapper">
            <div className="button">
              <FacebookShareButton url={circle_url}>
                <CustomIcon name="b2b-facebook" className="icon" size="24" />
              </FacebookShareButton>
            </div>
            <div className="button">
              <WhatsappShareButton url={circle_url}>
                <CustomIcon name="b2b-whatsapp" className="icon" size="24" />
              </WhatsappShareButton>
            </div>
            <div className="button">
              <EmailShareButton url={circle_url}>
                <CustomIcon name="b2b-email" className="icon" size="24" />
              </EmailShareButton>
            </div>

            <div className="button">
              <TwitterShareButton url={circle_url}>
                <CustomIcon name="b2b-twitter" className="icon" size="24" />
              </TwitterShareButton>
            </div>
            {/* <div className="button">
                    <CopyToClipboard text={circle_url} >
                        <span>
                            <CustomIcon name="b2b-url" className="icon" size="24" />
                        </span>
                    </CopyToClipboard>
                </div> */}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  circle: getCreatedCircle(state),
});

export default connect(mapStateToProps, null)(ShareYourGroup);
